<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"https:\/\/api.arair.ir\/storage\/asset\/hero.png","sectionContainerMode":"container"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تولدتون مبارک !   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-4" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-5" >
                <template #default>   <m-video v-bind='{...{"controls":true,"videoSrc":"https:\/\/api.arair.ir\/storage\/asset\/Img 2154.mp4","autoplay":false,"muted":false,"loop":false,"poster":"https:\/\/api.arair.ir\/storage\/asset\/poster.png"},...{}}' :style='"border-radius: 25px;\nmax-height:360px;"' class="shadow  img-fluid " ></m-video></template>
                </m-div></template>
                </m-div></template>
                </m-section-204>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mDiv,mH1,mVideo },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
